import styles from "./ProxyCheckmark.module.css";
import checkMark from "./Proxy_Vote_Icon.svg";

/**
 *
 * Displays a green check mark when someone is checked into a meeting.
 *
 */

export function ProxyCheckmark() {

  return (
    <div className={styles.container}>
      <img src={checkMark} className={styles.checkMark}/>
    </div>
  );
}

